import { 
         ALL_POKEMONS_REQUEST,
         ALL_POKEMONS_SUCCESS,
         ALL_POKEMONS_FAIL,

         CLEAR_ERRORS

       } from "../constants/allPokemonConstants"


//_______________fetch all pokemons
 export const getAllPokemonReducer = (state = {allPokemons: []}, action) => {
 
      switch(action.type) {

            case ALL_POKEMONS_REQUEST:
                return {
                    loading: true,
                    allPokemons:  [],
               }

            case ALL_POKEMONS_SUCCESS: 
                return {
                    allPokemons: action.payload,
                    loading: false
                }
            
            case ALL_POKEMONS_FAIL: 
                return {

                }
            case CLEAR_ERRORS:
                return {
                    ...state,
                    error: null
                }
            default:
                return state
      }
  
}






